export default __webpack_public_path__ + "static/5_PhotoBackground-e753b9c9d27bada7ba853afa711798a7.png";